// This base url is required to enable branch support. i.e
// For master: inspection/basic/29843983271983721/thank-you
// For branches: inspection/basic/__CFE-999/29843983271983721/thank-you
export function generateFunnelPath(config) {
  const configuredPath = getFunnelConfiguredPath(config);
  return "/" + configuredPath;
}

function getFunnelConfiguredPath(config) {
  if (config.routePathSchema) {
    return appendVersionPath(config.routePathSchema, config.env);
  }

  return config.funnelBaseUrl;
}

function appendVersionPath(path, env) {
  switch (env) {
    case 'qa':
      return path + "/(__[^/]*)";

    default:
      return path;
  }
}